module.exports = __webpack_public_path__ + "/bundle/asset/U2_07-ad4977962dc3f9e0f5c91acab791db1e.gif";